import * as React from "react";
import classNames from "classnames";
export interface CustomServiceOptionProps {
  innerRef: any;
  innerProps: any;
  data: any;
}

export const CustomServiceOption: React.FC<CustomServiceOptionProps> = ({
  innerRef,
  innerProps,
  data,
}) => {
  const isInactive = data.status === "inactive";
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={classNames(
        "flex items-center gap-2 p-2 px-4 cursor-pointer hover:bg-[#F5F3EF] z-[100]",
        {
          "hover:bg-gray-200": isInactive,
        }
      )}
      style={{ pointerEvents: isInactive ? "none" : "auto" }}
    >
      <div className="flex justify-between w-full gap-1">
        <p className="flex flex-col gap-1">
          <span
            className={`font-bold text-sm ${
              isInactive ? "text-gray-400" : "text-zinc-700"
            }`}
          >
            {data?.label}
          </span>
          <span className="text-xs text-zinc-500">
            {isInactive &&
              `${data?.employee?.name} does not provide this service`}
          </span>
        </p>
      </div>
    </div>
  );
};
